module.exports = __webpack_public_path__ + "static/media/img3.ca9b27b1.JPG";